module.exports = __webpack_public_path__ + "img/size_1_3.af5c6d9e.png";